@if (this.isDesktop) { @if (myThumbnail !== 'null') {
<lib-ngx-image-zoom
  [thumbImage]="myThumbnail"
  [fullImage]="myFullresImage"
  [magnification]="1"
  [enableScrollZoom]="true"
  [enableLens]="true"
  [lensWidth]="200"
></lib-ngx-image-zoom>
} } @else { @if (myThumbnail !== 'null') {
<lib-ngx-image-zoom
  class="img-zoom"
  [thumbImage]="myThumbnail"
  [fullImage]="myFullresImage"
  [magnification]="1"
  [enableScrollZoom]="true"
  [zoomMode]="'click'"
  [enableLens]="true"
  [lensHeight]="100"
  [lensWidth]="163"
></lib-ngx-image-zoom>
} }
